/**
 * 描述：评价系统 --- 评分记录 接口管理
 * 录入人： 王帅
 */
import request from '../request.js'
/**
* 描述：查询评分记录列表数据
* 接口管理员：俞祥东
* 参数： 
{
      "pageSize": "10",
      "current": "1",
      "objName": "", //评价项目
      "source": "", //业务来源
      "judger": "", //评价人
      "beJudger": "", //被评价人
      "markResult": "", //评价结果
      "startTime": "", //评价时间
      "endTime": "" //评价时间
      }
}
*/
export const getRecordsData = function (data) {
    return request({
        url: 'markRecord/selOperateMarkRecordPageList',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}

/**
* 描述：查询评分记录详细数据
* 接口管理员：俞祥东
* 参数： 
{
    "id": ""
    "judgeRoleName": "", //评价角色名称
    "beJudgeRoleName": "", //被评价角色名称
    "markObjName": "", //评价对象
    "sourceName": "", //业务来源名称
      }
}
*/
export const getRecordsDetail = function (data) {
    return request({
        url: 'markRecord/selOperateMarkRecordInfo',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}